import React from 'react';
import classes from './Loader.module.scss';
import CountDown from '../CountDown/CountDown';

const Loader = props => {
    const { loadingMessage, showCountDown} = props;
    
    return (
        <div className="common-container" style={{position: 'relative', minHeight:'300px'}}>
            {showCountDown ? <CountDown marginTop={'90px'} marginBottom={'30px'} /> : ''}
            <div className={classes.LoadingText}>
                Loading...
            </div>
            <div className={classes.LoadingSubText}>
                { loadingMessage }
            </div>
        </div>
    );
}

export default Loader;
